import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DownloadExcelComponent } from "./download-excel.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
    declarations: [
        DownloadExcelComponent
    ],
    exports: [
        DownloadExcelComponent
    ]
})
export class DownloadExcelModule { }
